import { c as _c } from "react/compiler-runtime";
import { Flag } from '@7f-ui/components/flag/flag';
type DestinationsTagsProps = {
  tags: string[];
};
export function DestinationsTags(t0) {
  const $ = _c(4);
  const {
    tags
  } = t0;
  let t1;
  if ($[0] !== tags) {
    t1 = tags.slice(0, 3).map(_temp);
    $[0] = tags;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <ul className="flex flex-wrap gap-2">{t1}</ul>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(tag) {
  return <li key={tag}><Flag>{tag}</Flag></li>;
}